import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/list-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM458 432H54A6-6 0 0 0 48 426V86A6-6 0 0 0 54 80H458A6-6 0 0 0 464 86V426A6-6 0 0 0 458 432zM416 340V364C416 370.6 410.6 376 404 376H204C197.4 376 192 370.6 192 364V340C192 333.4 197.4 328 204 328H404C410.6 328 416 333.4 416 340zM416 244V268C416 274.6 410.6 280 404 280H204C197.4 280 192 274.6 192 268V244C192 237.4 197.4 232 204 232H404C410.6 232 416 237.4 416 244zM416 148V172C416 178.6 410.6 184 404 184H204C197.4 184 192 178.6 192 172V148C192 141.4 197.4 136 204 136H404C410.6 136 416 141.4 416 148zM164 160C164 179.9 147.9 196 128 196S92 179.9 92 160 108.1 124 128 124 164 140.1 164 160zM164 256C164 275.9 147.9 292 128 292S92 275.9 92 256 108.1 220 128 220 164 236.1 164 256zM164 352C164 371.9 147.9 388 128 388S92 371.9 92 352 108.1 316 128 316 164 332.1 164 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/list-alt.js
// module id = UZYE
// module chunks = 144